export default "__VITE_ASSET__CyPFIN_V__"